import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import PlaywatchSettings from './playwatch-settings-model'
import {
  CreatePlaywatchSettingsAsync,
  DeletePlaywatchSettingsAsync,
  LoadPlaywatchSettingssAsync,
} from './playwatchSettings-thunk'
const initialState: playwatchSettingsSliceState = {
  playwatchSettings: [],
  selected_playwatchSettings: '',
  is_loading_playwatchSettings: false,
  is_creating_playwatchSettings: false,
  is_deleting_playwatchSettings: false,
}
export interface playwatchSettingsSliceState {
  playwatchSettings: PlaywatchSettings[]
  selected_playwatchSettings?: string
  is_loading_playwatchSettings: boolean
  is_creating_playwatchSettings: boolean
  is_deleting_playwatchSettings: boolean
}
export const playwatchSettingsSlice = createSlice({
  name: 'playwatchSettings',
  initialState,
  reducers: {
    setSelectedplaywatchSettings: (state, action) => {
      state.selected_playwatchSettings = action.payload
    },
    clearStateplaywatchSettings: (state) => {
      state.playwatchSettings = []
      state.is_loading_playwatchSettings = false
      state.is_creating_playwatchSettings = false
      state.is_deleting_playwatchSettings = false
    },
    mergeplaywatchSettings: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_playwatchSettings = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.playwatchSettings = merge(
            state.playwatchSettings,
            payload,
          ) as any
        }
      }
    },

    add_playwatchSettings: (state, action) => {
      if (action.payload) {
        state.playwatchSettings = [...state.playwatchSettings, action.payload]
      }
    },
    set_playwatchSettings: (state, action) => {
      let { key, value, id } = action.payload
      state.playwatchSettings = state.playwatchSettings.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPlaywatchSettingssAsync.pending, (state) => {
      state.is_loading_playwatchSettings = true
    })
    builder.addCase(LoadPlaywatchSettingssAsync.fulfilled, (state, action) => {
      state.is_loading_playwatchSettings = false
      if (action.payload) {
        state.playwatchSettings = action.payload
      }
    })
    builder.addCase(LoadPlaywatchSettingssAsync.rejected, (state) => {
      state.is_loading_playwatchSettings = false
    })
    builder.addCase(CreatePlaywatchSettingsAsync.pending, (state) => {
      state.is_creating_playwatchSettings = true
    })
    builder.addCase(CreatePlaywatchSettingsAsync.fulfilled, (state) => {
      state.is_creating_playwatchSettings = false
    })
    builder.addCase(CreatePlaywatchSettingsAsync.rejected, (state) => {
      state.is_creating_playwatchSettings = false
    })
    builder.addCase(DeletePlaywatchSettingsAsync.pending, (state) => {
      state.is_deleting_playwatchSettings = true
    })
    builder.addCase(DeletePlaywatchSettingsAsync.fulfilled, (state, action) => {
      state.is_deleting_playwatchSettings = false
      if (state.playwatchSettings) {
        state.playwatchSettings = state.playwatchSettings.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePlaywatchSettingsAsync.rejected, (state) => {
      state.is_deleting_playwatchSettings = false
    })
  },
})

export const {
  clearStateplaywatchSettings,
  setSelectedplaywatchSettings,
  set_playwatchSettings,
  mergeplaywatchSettings,
  add_playwatchSettings,
} = playwatchSettingsSlice.actions

export const get_playwatchSettings =
  (id?: string) =>
  (state: {
    playwatchSettings: {
      playwatchSettings: PlaywatchSettings[]
    }
  }): PlaywatchSettings | null => {
    let temp = state?.playwatchSettings?.playwatchSettings?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.playwatchSettings?.playwatchSettings[0] || null
  }
export const get_selected_playwatchSettings = (state: {
  playwatchSettings: playwatchSettingsSliceState
}): PlaywatchSettings | null => {
  let id = state?.playwatchSettings?.selected_playwatchSettings
  let temp = state?.playwatchSettings?.playwatchSettings?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_playwatchSettings = (state: {
  playwatchSettings: {
    playwatchSettings: PlaywatchSettings[]
  }
}): PlaywatchSettings[] => {
  let temp = state?.playwatchSettings?.playwatchSettings
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_playwatchSettings_busy = (state: {
  playwatchSettings: playwatchSettingsSliceState
}) => {
  return (
    state?.playwatchSettings.is_deleting_playwatchSettings ||
    state?.playwatchSettings.is_loading_playwatchSettings ||
    state?.playwatchSettings.is_creating_playwatchSettings
  )
}
export const is_deleting_playwatchSettings_busy = (state: {
  playwatchSettings: playwatchSettingsSliceState
}) => {
  return state?.playwatchSettings.is_deleting_playwatchSettings
}
export const is_loading_playwatchSettings_busy = (state: {
  playwatchSettings: playwatchSettingsSliceState
}) => {
  return state?.playwatchSettings.is_loading_playwatchSettings
}
export const is_creating_playwatchSettings_busy = (state: {
  playwatchSettings: playwatchSettingsSliceState
}) => {
  return state?.playwatchSettings.is_creating_playwatchSettings
}

export default playwatchSettingsSlice.reducer
